import Vue from 'vue'
import router from './router'
import axios from 'axios'
import App from './App.vue'
import {bindPageTopLinks} from './scroll'

// 「↑このページの先頭へ」リンクを有効にする
bindPageTopLinks()

new Vue({
  el: '#app',
  axios,
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js